import React from 'react';
import {Exclusions} from "./components/Exclusions";
import {createRoot} from "react-dom/client";

function initExclusions(config: any) {
    const element = document.getElementById('ts-exclusions-modal');
    if (element) {
        const root = createRoot(element!);
        root.render(<Exclusions id="ts-exclusions-modal" config={config} />);
    }
}

export default initExclusions;
